import * as React from 'react';

const IconCalendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" width="1em" height="1em" {...props}>
    <path
      clipRule="evenodd"
      d="M2 6.167a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5V20.5a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 20.5V6.167z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 10h20M7.333 6.667V2M16.666 6.667V2M6.333 13.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667M6.333 18a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667M12 13.333A.333.333 0 1 0 12 14a.333.333 0 0 0 0-.667M12 18a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667M17.667 13.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667M17.667 18a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCalendar;
